/*
 * @Author: Teemo Ding
 * @Date: 2021-12-24 11:18:42
 * @LastEditTime: 2021-12-30 11:22:41
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/SubscriptionBuyEdit/OrderRecords/index.tsx
 */
import React from 'react';
//import { get } from 'lodash';
import { Form } from 'antd';
import { SectionWrapper } from 'src/components/Layouts';
import OrderRecordsTable from '../../../Components/ProductsItems/OrderRecordsTable';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const OrderRecords = (props) => {
  const { currency } = props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      title={getI18n(
        'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_Orderrecord_title',
      )}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      {/* <Form.Item
        noStyle
        shouldUpdate={(p, c) => {
          const cC = get(c, 'salesChannel.uuid');
          const pC = get(p, 'salesChannel.uuid');
          return cC !== pC;
        }}>
        {({ getFieldValue }: any) => ( */}
      <Form.Item name='orderRecords' initialValue={[]} noStyle>
        <OrderRecordsTable currency={currency} />
      </Form.Item>
      {/* )}
      </Form.Item>; */}
    </SectionWrapper>
  );
};

export default OrderRecords;
